import { useEffect, useState } from 'react';
import {Text, Image} from '@ui/atoms';
import AccordionItem from '@ui/molecules/Faq/AccordionItem';

const Accordion = ({ section }) => {
    const { header, questionBank, defaultOpen, headerTextSize = 'p3-semibold md:h5-semibold' } = section;
    const [isOpen, setIsOpen] = useState(false);

    const addHashToUrl = () => {
        history.replaceState(null, '', `#${section.id}`);
    };

    const toggleAccordian = () => {
        if (!isOpen) {
            addHashToUrl();
        }
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        if(defaultOpen) setIsOpen(defaultOpen)
    },[])

    return (
        <div className="mt-8 md:mt-10 xl:mt-12 duration-1000 ease-in-out transition-height">
            <div className="flex gap-2 pb-3 border-gray-300 border-b-1">
                <div
                    id={section.id}
                    className="flex items-center justify-between flex-grow cursor-pointer"
                    onClick={toggleAccordian}
                >
                    <Text
                        className={`${headerTextSize} text-primary-500`}
                        content={header}
                        htmlTag="h3"
                    />
                    {!isOpen ? (
                        <Image
                            className="!w-4 md:!w-5 transition-all duration-200 ease-linear transform rotate-180"
                            src={'/images/arrow-down-primary.svg'}
                            alt={'arrow_down'}
                        />
                    ) : (
                        <Image
                            className="!w-4 md:!w-5 transition-all duration-200 ease-linear"
                            src={'/images/arrow-down-primary.svg'}
                            alt={'arrow_down'}
                        />
                    )}
                </div>
            </div>
            <div className={`mt-3 ml-2 ${isOpen ? 'block' : 'hidden'}`}>
                {questionBank.map((item, index) => (
                    <div key={index} className="mt-4">
                        <AccordionItem
                            question={item.question}
                            answer={item.answer}
                            haveInnerHtml={item.haveInnerHtml}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Accordion;
